export default class TsdiInvoiceGroupRequest {
  groupIrNumber: number;
  groupId: number;
  closeRequestDate?: Date;
  closeDate?: Date;
  closedByNumber?: number;
  closedByName?: string;
  clientName?: string;
  clientAddress?: string;
  clientAddress2?: string;
  clientAddress3?: string;
  clientContact?: string;
  clientCity?: string;
  clientState?: string;
  clientZip?: string;
  salutation?: string;
  signatureName?: string;
  signatureTitle?: string;
  firstParagraph?: string;
  projectName?: string;
  wellName?: string;
  parcels?: string;
  qlsNumbers?: string;
  afeNumbers?: string;
  secondParagraph?: string;
  letterDate?: Date;
  municipalities?: string;
  beginDate?: Date;
  endDate?: Date;
  closureRequest?: number;

  /** Runtime type map */
  static propertyTypes: Record<keyof TsdiInvoiceGroupRequest, 'number' | 'string' | 'date'> = {
    groupIrNumber: 'number',
    groupId: 'number',
    closeRequestDate: 'date',
    closeDate: 'date',
    closedByNumber: 'number',
    closedByName: 'string',
    clientName: 'string',
    clientAddress: 'string',
    clientAddress2: 'string',
    clientAddress3: 'string',
    clientContact: 'string',
    clientCity: 'string',
    clientState: 'string',
    clientZip: 'string',
    salutation: 'string',
    signatureName: 'string',
    signatureTitle: 'string',
    firstParagraph: 'string',
    projectName: 'string',
    wellName: 'string',
    parcels: 'string',
    qlsNumbers: 'string',
    afeNumbers: 'string',
    secondParagraph: 'string',
    letterDate: 'date',
    municipalities: 'string',
    beginDate: 'date',
    endDate: 'date',
    closureRequest: 'number',
  };
}


// WEBPACK FOOTER //
// ./src/components/project-billing/models/InvoiceGroupRequest.ts